const ZA_PREFIX = '+27';

export const toLocalDigits = (value) => {
  if (!value) return '';
  const digits = value.replace(/[^\d+]/g, '');
  if (digits.startsWith('+27')) return digits.slice(3);
  if (digits.startsWith('27')) return digits.slice(2);
  if (digits.startsWith('0')) return digits.slice(1);
  return digits.replace('+', '');
};

export const toZAPhone = (localDigits) => (localDigits ? `${ZA_PREFIX}${localDigits}` : '');

export const isValidZAPhone = (value) => /^\+27[1-9]\d{8}$/.test(value ?? '');
